<template>
  <div id="app">
    <router-view />
    <!-- <img class="ai-img" src="@/assets/images/ai.png" @click="aiClick" alt="" />
    <AIdialogue ref="AIdialogue"></AIdialogue> -->
  </div>
</template>

<script>
import AIdialogue from "@/components/AIdialogue.vue";
export default {
  name: "App",
  components: { AIdialogue },
  created() {
    window.document.documentElement.setAttribute("data-theme", "d");
    this.getRem(1920, 100);
    window.onresize = () => {
      this.getRem(1920, 100);
    };
  },
  mounted() {
    // window.addEventListener("beforeunload", this.handleBeforeUnload);

  },
  methods: {
    // 设置根大小，元素宽高字体大小都可以用rem,10px = 0.1rem
    getRem(pwidth, prem) {
      var html = document.getElementsByTagName("html")[0];
      var oWidth =
        document.body.clientWidth || document.documentElement.clientWidth;
      html.style.fontSize = (oWidth / pwidth) * prem + "px";
    },

    aiClick() {
      this.$refs.AIdialogue.init();
    },
    // handleBeforeUnload() {
    //   // 清除 localStorage 中的数据
    //   localStorage.clear();
    // },
  },
  // beforeDestroy() {
  //   window.removeEventListener("beforeunload", this.handleBeforeUnload);
  // },
};
</script>

<style scoped lang="scss">
#app {
  position: relative;
}
.ai-img {
  width: 48px;
  height: 48px;
  position: fixed;
  right: 50px;
  bottom: 10%;
  cursor: pointer;
  z-index: 9;
  animation: bg-move_integration_dOHel 1s linear infinite,
    bg-shadow-move_integration_MV4EH 1s linear infinite;
  border: 0.5px solid rgba(36, 104, 242, 0.5);
  border-radius: 50%;
}
@keyframes bg-move_integration_dOHel {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.05);
  }
  50% {
    transform: scale(1.1);
  }
  75% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes bg-move_integration_MV4EH {
  0% {
    box-shadow: 0 0 0 0 rgba(36, 104, 242, 0.2);
  }
  100% {
    box-shadow: 0 0 0 12px rgba(36, 104, 242, 0);
  }
}
</style>
